export default __webpack_public_path__ + "static/media/storage.607ab9b6.svg";